import titles from "@/store/lang/titles.json";
import { mapGetters, mapActions } from "vuex";
import Success from "../success/Success.vue";
import Tooltip from "../tooltip/tooltip.vue";
import InvisibleRecaptcha from "vue-invisible-recaptcha";
export default {
  name: "DeliveryDateConfirmation",
  components: {
    Success,
    Tooltip,
    InvisibleRecaptcha,
  },
  data() {
    return {
      deliveryDateConfirmation: titles.deliveryDateConfirmation,
      isActiveFrontDoor: false,
      isActiveRearDoor: false,
      confirmationOfEnoughSpace: false,
      panelOpen: 0,
      deliveryDateValid: false,
      deliveryDateTick: false,
      orderDetailsTick: false,
      confirmDeliveryDate: false,
      deliveryConditionsValid: false,
      deliveryConditionsTick: false,
      otherInfoTick: false,
      verificationValid: false,
      verificationTick: false,
      loading: false,
      newRequestedDateMenu: false,
      dateFormatted: "",
      date: "",
      rulesTitles: titles.rulesTitle.deliveryDate,
      rules: {
        requiredRules: [
          (v) => !!v || titles.rulesTitle.deliveryDate.fieldIsRequired,
        ],
      },
      requestForm: {
        event_type: "delivery_date_confirmation_request",
        rfq_name: "",
        order_number: "",
        order_header_id: 0,
        rfq_id: 0,
        delivery_date_confirm: "",
        original_delivery_date: "",
        new_requested_date: "",
        door_level_confirm: "",
        signature: "",
        additional_info: "",
        hauler_note: "",
        site_contact: "",
        container_description: "",
        door_direction: "",
        customer_name: "",
        email: "",
        shipping_address: "",
        quantity: 0,
        CountryCode: "",
      },
      isSubmitSuccessful: false,
      activeStep: 1,
      animation: "animate-in",
      orderDetails: null,
      isSubmitting: false,
      logisticsPhone: {
        US: "(800) 768-6080",
        CA: "(800) 925-2515"
      }
    };
  },
  computed: {
    ...mapGetters(["getCountryCode"]),
    progress() {
      var pg = (this.activeStep - 1) / 4 * 100;
      return pg;
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    ...mapActions(["addFormRequest", "getFormRequest"]),
    validateDeliveryDateFields() {
      //Check if delivery_date_confirm is false. If false check if dateFormatted is selected

      this.deliveryDateValid =
        this.$refs.deliveryDateForm.validate() &&
        (this.requestForm.delivery_date_confirm === "false"
          ? this.dateFormatted.length > 0
          : true);
      this.deliveryDateTick = this.deliveryDateValid;
      return this.deliveryDateValid;
    },
    validateDeliveryConditionsFields() {
      this.deliveryConditionsValid = this.$refs.deliveryConditionsForm.validate();
      this.deliveryConditionsTick = this.deliveryConditionsValid;
      return this.deliveryConditionsValid;
    },
    validateSignatureFields() {
      this.verificationValid = this.$refs.verificationForm.validate();
      this.verificationTick = this.verificationValid;
      return this.verificationValid;
    },
    getPriorPanel(event, idx) {
      event ? event.preventDefault() : null;
      switch (idx) {
        case 2:
          this.priorStep();
          break;
        case 3:
          this.priorStep();
          break;
        case 4:
          this.priorStep();
          break;
        case 5:
          this.priorStep();
          break;
      }
    },

    getNextPanel(event, idx) {
      switch (idx) {
        case 1:
          this.orderDetailsTick = true;
          this.nextStep();
          break;
        case 2:
          if (!this.validateDeliveryDateFields()) this.notValid();
          else {
            this.requestForm.new_requested_date =
              this.requestForm.delivery_date_confirm === "false"
                ? this.parseDate(
                  this.dateFormatted
                )
                : "";
            this.nextStep();
          }
          break;
        case 3:
          !this.validateDeliveryConditionsFields()
            ? this.notValid()
            : this.nextStep();
          break;
        case 4:
          this.otherInfoTick = true;
          this.nextStep();
          break;
        case 5:
          if (!this.validateSignatureFields()) this.notValid();
          else this.submit();
          break;
      }
    },
    submit() {
      this.panelOpen = null;
      this.requestForm.CountryCode = this.getCountryCode;
      this.isSubmitting = true;
      this.requestForm.additional_info = JSON.stringify(this.requestForm.additional_info);
      this.requestForm.additional_info = this.requestForm.additional_info.slice(1, -1);

      this.addFormRequest({
        data: this.requestForm,
        event_type: this.requestForm.event_type,
      })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.ResponseMetadata &&
            response.data.ResponseMetadata.HTTPStatusCode == 200
          )
            this.isSubmitSuccessful = true;
          this.isSubmitting = false;
        })
        .catch((err) => {
          console.log(err);
          this.isSubmitting = false;
        });
    },
    priorStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep -= 1;
      }, 600);
    },
    nextStep() {
      this.animation = "animate-out";
      setTimeout(() => {
        this.animation = "animate-in";
        this.activeStep += 1;
      }, 600);
    },
    notValid() {
      this.animation = "animate-wrong";
      setTimeout(() => {
        this.animation = "";
      }, 400);
    },
    getStepperContent(step) {
      this.activeStep = step;
      switch (step) {
        case 1:
          this.orderDetailsTick = false;
          break;
        case 2:
          this.deliveryDateTick = false;
          break;
        case 3:
          this.deliveryConditionsTick = false;
          break;
        case 4:
          this.otherInfoTick = false;
          break;
        case 5:
          this.verificationTick = false;
          break;
      }
    },
    isAllValid() {
      return (
        !(
          this.orderDetailsTick &&
          this.deliveryDateTick &&
          this.deliveryConditionsTick &&
          this.otherInfoTick &&
          this.requestForm.signature
        ) || this.isSubmitting
      );
    },
    submitted(response) {
      /*resposne will have the reCAPTCHA token.
      If token is null or empty do nothing.*/
      if (!response) return;
      this.getNextPanel(null, this.activeStep);
    },
    /*Get the order details/predelivery/hauler note/rfq using
    the encrypted query parameter "o"*/
    getOrderDeatils() {
      this.loading = true;

      this.getFormRequest({
        id: this.$route.query.o,
        event_type: this.requestForm.event_type,
      })
        .then((response) => {
          if (
            response.data &&
            response.data.statusCode == 200 &&
            response.data.body
          ) {
            this.orderDetails = response.data.body;
            this.requestForm.rfq_name = this.orderDetails.RFQ_Name;
            this.requestForm.order_number = this.orderDetails.Order_Number;
            this.requestForm.order_header_id = this.orderDetails.Order_Header_Id;
            this.requestForm.rfq_id = this.orderDetails.RFQ_Id;
            this.requestForm.original_delivery_date = this.orderDetails.Delivery_Date;
            this.requestForm.hauler_note = this.orderDetails.Hauler_Note;
            this.requestForm.site_contact =
              this.orderDetails.ORDER_CONTACT_NAME +
              " / " +
              this.orderDetails.ORDER_CONTACT_PHONENUMBER;
            this.requestForm.container_description = this.orderDetails.Description;
            this.requestForm.door_direction = this.orderDetails.DOOR_DIRECTION;
            this.requestForm.customer_name = this.orderDetails.Customer_Name;
            this.requestForm.email = this.orderDetails.Email;
            this.requestForm.shipping_address = this.orderDetails.ShippingAddress;
            this.requestForm.quantity = this.orderDetails.Quantity;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
  mounted() {
    if (this.$route.query.o) this.getOrderDeatils();
  },
};
